'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoOrganization = function GoOrganization(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 15h-25c-2.8 0-5 2.2-5 5v2.5c0 1.8 1 3.4 2.5 4.3v8.2h10v5h10v-5h10v-8.2c1.5-0.9 2.5-2.5 2.5-4.3v-2.5c0-2.8-2.2-5-5-5z m-20 17.5h-5v-10h-2.5v-2.5c0-1.4 1.1-2.5 2.5-2.5h3.2c-0.4 0.7-0.7 1.6-0.7 2.5v5c0 1.8 1 3.4 2.5 4.3v3.2z m12.5-5v-5h-2.5v15h-5v-15h-2.5v5c-1.4 0-2.5-1.1-2.5-2.5v-5c0-1.4 1.1-2.5 2.5-2.5h10c1.4 0 2.5 1.1 2.5 2.5v5c0 1.4-1.1 2.5-2.5 2.5z m10-5h-2.5v10h-5v-3.2c1.5-0.9 2.5-2.5 2.5-4.3v-5c0-0.9-0.3-1.8-0.7-2.5h3.2c1.4 0 2.5 1.1 2.5 2.5v2.5z m-20.6-10.1c1.3 1.6 3.3 2.6 5.6 2.6 2.3 0 4.3-1 5.6-2.6 0.9 1.5 2.5 2.6 4.4 2.6 2.8 0 5-2.2 5-5s-2.2-5-5-5c-1 0-1.9 0.3-2.7 0.8-0.8-3.3-3.7-5.8-7.3-5.8s-6.5 2.5-7.3 5.8c-0.8-0.5-1.7-0.8-2.7-0.8-2.8 0-5 2.2-5 5s2.2 5 5 5c1.9 0 3.5-1.1 4.4-2.6z m15.6-4.9c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5z m-10-5c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5z m-10 10c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5z' })
        )
    );
};

exports.default = GoOrganization;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/organization.js
// module id = 1956
// module chunks = 0